import { CommonModule } from '@angular/common';
import { Component, HostListener, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { DrawerModule } from 'primeng/drawer';
import { UserService } from '../../../core/services/user.service';
import { BaseResponse } from '../../../core/interfaces/base-response';
import { User } from '../../../core/interfaces/user';
import { USER_DATA } from '../../../core/utils/constant';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    HeaderComponent,
    SidebarComponent,
    DrawerModule,
  ],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.css',
})
export class MainLayoutComponent implements OnInit {
  private userService = inject(UserService);

  visible = false;
  mode: 'overlay' | 'push' = 'overlay';

  constructor() {
    this.setSidebarVisibility();
  }

  ngOnInit() {
    this.setSidebarVisibility();

    this.userService.getCurrentUser().subscribe({
      next: (response: BaseResponse<User>) => {
        const role = JSON.parse(localStorage.getItem(USER_DATA) || '')?.role;
        const user = { ...response.data, role };
        localStorage.setItem(USER_DATA, JSON.stringify(user));
      },
    });
  }

  @HostListener('window:resize', [])
  onResize() {
    this.setSidebarVisibility();
  }

  setSidebarVisibility() {
    this.visible = window.innerWidth > 1280;
    this.mode = window.innerWidth > 1280 ? 'push' : 'overlay';
    this.updateBodyOverflow();
  }

  toggleSidebar() {
    this.visible = !this.visible;
    this.updateBodyOverflow();
  }

  updateBodyOverflow() {
    if (this.visible && this.mode === 'overlay') {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }
}
